import { render, staticRenderFns } from "./TxnDirect.vue?vue&type=template&id=d18d6fbe&"
import script from "./TxnDirect.vue?vue&type=script&lang=ts&"
export * from "./TxnDirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports